import { RouteProps } from '../../routes/AppRouter'
import { Table as FGU } from '../../features/form-generator/Table'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { useLocation } from 'react-router-dom'

type FormGeneratorUserProps = {
  selectedCircle?: string
} & RouteProps

export function FormGeneratorUsers(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const location = useLocation()

  setTitle(title)
  const state: FormGeneratorUserProps = location?.state as FormGeneratorUserProps

  return (
    <>
      <FGU></FGU>
    </>
  )
}
